module.exports = __webpack_public_path__ + "img/userAvatar.4491e84d.png";